import React from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import './CustomDatePicker.scss'

interface IProps {
  startDate?: any,
  onChangeDate?: any,
  selected?: any,
  'data-attribute'?: any
}

const CustomDatePickerContainer = ({
  startDate = '',
  onChangeDate,
  'data-attribute': dataAttribute
}:IProps) => {
  return <DatePicker selected={startDate} onChange={onChangeDate} data-attribute={dataAttribute} />
}

export default CustomDatePickerContainer
